import { Coin } from '../../atoms'
import type { CoinColorType } from '../../atoms/Coin'
import * as style from './index.css'

export const CoinPile = (props: {
  contributions: number[]
  bigBlind: number
}) => {
  const chipMultipliers: Record<CoinColorType, number> = {
    blue: 1,
    green: 2,
    violet: 5,
    purple: 10,
    yellow: 20,
    orange: 50,
    red: 100,
    pink: 200,
  }

  const chipValues = Object.entries(chipMultipliers).reduce<
    Record<CoinColorType, number>
  >(
    (obj, [color, multiplier]) => {
      obj[color as CoinColorType] = props.bigBlind * multiplier
      return obj
    },
    {} as Record<CoinColorType, number>,
  )

  const calculateCoins = (contribution: number) => {
    let remainder = contribution
    const coins: { color: CoinColorType }[] = []
    const sortedChipTypes = (Object.keys(chipValues) as CoinColorType[]).sort(
      (a, b) => chipValues[b] - chipValues[a],
    )
    for (const color of sortedChipTypes) {
      const coinValue = chipValues[color]
      const count = Math.floor(remainder / coinValue)
      if (count > 0) {
        coins.push(
          ...Array.from({ length: count }, () => ({
            color,
          })),
        )
        remainder %= coinValue
      }
    }
    if (remainder > 0) {
      const smallestCoin = sortedChipTypes[sortedChipTypes.length - 1]
      coins.push({ color: smallestCoin })
    }
    return coins
  }

  const allCoins = props.contributions.reduce<{ color: CoinColorType }[]>(
    (acc, contribution) => acc.concat(calculateCoins(contribution)),
    [],
  )

  const sortedCoins = allCoins.sort(
    (a, b) => chipValues[b.color] - chipValues[a.color],
  )

  const pileSize = 10
  const piles = []
  for (let i = 0; i < sortedCoins.length; i += pileSize) {
    piles.push(sortedCoins.slice(i, i + pileSize))
  }

  return (
    <div className={style.pileContainer}>
      {piles.map((pile, pileIndex) => (
        <div
          key={pileIndex}
          className={style.pile}
        >
          {pile.map((coin, coinIndex) => (
            <div
              key={`${coinIndex}-${coin.color}`}
              className={style.coinWrapper}
              style={{ zIndex: coinIndex }}
            >
              <Coin
                color={coin.color}
                className={style.coin}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
